import React from 'react'
import cx from 'classnames'
import './index.scss'

const ProductSection3 = ({ className, title, image, type = 'row' }) => {
  const prefix = 'product-section3'

  return (
    <section
      className={cx(
        prefix,
        `${prefix}-decorator`,
        `${prefix}-${type}`,
        className
      )}
    >
      <div className="info">
        <div className="title">{title}</div>
      </div>
      <div className="image">{image}</div>
    </section>
  )
}

export default ProductSection3
